import { useCallback, useState } from "react";
import { useAppDispatch } from "../../../store";
import { cancelEmail } from "../../../acions/emails";

export const useCancelEmail = (id: string, onCanceled: () => void) => {
  const [disabled, setDisabled] = useState<boolean>(false);

  const dispatch = useAppDispatch();

  const remove = useCallback(async () => {
    try {
      setDisabled(true);

      await Promise.resolve(dispatch(cancelEmail(id)));

      setDisabled(false);

      onCanceled();
    } catch {
      setDisabled(false);
    }
  }, [dispatch, id, onCanceled]);

  return { disabled, remove };
};
